const NUMBER_LOCALE = 'en-US'
const EMPTY = '—'

interface FormatNumberOptions {
  decimals?: number
  emptyFallback?: string
  groupSeparator?: ',' | ' '
}

export function formatNumber(
  value: number | undefined | null,
  options: FormatNumberOptions = {},
): string {
  const { decimals = 0, emptyFallback = EMPTY, groupSeparator = ',' } = options
  if (value == null || !Number.isFinite(value)) return emptyFallback
  const formatted = value.toLocaleString(NUMBER_LOCALE, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
  return groupSeparator === ' ' ? formatted.replaceAll(',', ' ') : formatted
}
